import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
export let lastModified = undefined;
export let frontmatter = {
  "title": "prune",
  "description": "`turbo prune` 명령어에 대한 API 레퍼런스"
};
export let structuredData = {
  "contents": [{
    "heading": "",
    "content": "대상 패키지에 대한 부분 모노레포를 생성합니다. 출력은 다음을 포함하는 out이라는 디렉토리에 배치됩니다:"
  }, {
    "heading": "",
    "content": "대상을 빌드하는 데 필요한 모든 내부 패키지의 전체 소스 코드."
  }, {
    "heading": "",
    "content": "대상을 빌드하는 데 필요한 원본 lockfile의 하위 집합을 포함하는 정리된 lockfile."
  }, {
    "heading": "",
    "content": "루트 package.json의 복사본."
  }, {
    "heading": "예제",
    "content": "다음 구조의 저장소로 시작합니다:"
  }, {
    "heading": "예제",
    "content": "turbo prune frontend를 실행하여 out 디렉토리에 frontend 애플리케이션에 대한 정리된 워크스페이스를 생성합니다:"
  }, {
    "heading": "--docker",
    "content": "기본값: false."
  }, {
    "heading": "--docker",
    "content": "Docker 모범 사례 및 레이어 캐싱과 함께 사용하기 쉽도록 출력 디렉토리를 변경합니다. 디렉토리에는 다음이 포함됩니다:"
  }, {
    "heading": "--docker",
    "content": "정리된 워크스페이스의 package.json 파일이 있는 json이라는 폴더."
  }, {
    "heading": "--docker",
    "content": "대상을 빌드하는 데 필요한 내부 패키지의 정리된 워크스페이스 전체 소스 코드가 있는 full이라는 폴더."
  }, {
    "heading": "--docker",
    "content": "대상을 빌드하는 데 필요한 원본 lockfile의 하위 집합을 포함하는 정리된 lockfile."
  }, {
    "heading": "--docker",
    "content": "위의 동일한 예제를 사용하여 turbo prune frontend --docker를 실행하면 다음이 생성됩니다:"
  }, {
    "heading": "--out-dir-path",
    "content": "기본값: ./out."
  }, {
    "heading": "--out-dir-path",
    "content": "정리된 출력이 생성되는 디렉토리를 사용자 정의합니다."
  }, {
    "heading": "--use-gitignorebool",
    "content": "기본값: true"
  }, {
    "heading": "--use-gitignorebool",
    "content": "출력 디렉토리로 파일을 복사할 때 .gitignore 파일을 준수합니다."
  }, {
    "heading": "pnpm-deploy와의-비교",
    "content": "turbo prune와 pnpm deploy 모두 모노레포의 패키지를 격리하는 데 사용되지만 서로 다른 목적을 제공하고 다른 출력을 생성합니다."
  }, {
    "heading": "pnpm-deploy와의-비교",
    "content": "turbo prune이 부분 모노레포를 생성하는 반면, pnpm deploy는 대상 패키지의 내용만 포함하는 디렉토리를 생성합니다."
  }, {
    "heading": "pnpm-deploy와의-비교",
    "content": "pnpm deploy가 생성한 디렉토리에는 하드 링크된 내부 의존성이 있는 자체 포함된 node_modules가 있습니다.\n이로 인해 서버에 직접 복사하여 추가 단계 없이 사용할 수 있는 이식 가능한 패키지가 생성됩니다.\n저장소 구조는 유지되지 않는데, 이는 독립 실행형 배포 가능 패키지를 생성하는 데 중점을 두기 때문입니다."
  }],
  "headings": [{
    "id": "예제",
    "content": "예제"
  }, {
    "id": "옵션",
    "content": "옵션"
  }, {
    "id": "--docker",
    "content": "--docker"
  }, {
    "id": "--out-dir-path",
    "content": "--out-dir <path>"
  }, {
    "id": "--use-gitignorebool",
    "content": "--use-gitignore[=<bool>]"
  }, {
    "id": "pnpm-deploy와의-비교",
    "content": "pnpm deploy와의 비교"
  }]
};
import {File, Folder, Files} from '#components/files';
export const toc = [{
  depth: 3,
  url: "#예제",
  title: _jsx(_Fragment, {
    children: "예제"
  })
}, {
  depth: 3,
  url: "#옵션",
  title: _jsx(_Fragment, {
    children: "옵션"
  })
}, {
  depth: 4,
  url: "#--docker",
  title: _jsx(_Fragment, {
    children: _jsx("code", {
      children: "--docker"
    })
  })
}, {
  depth: 4,
  url: "#--out-dir-path",
  title: _jsx(_Fragment, {
    children: _jsx("code", {
      children: "--out-dir <path>"
    })
  })
}, {
  depth: 4,
  url: "#--use-gitignorebool",
  title: _jsx(_Fragment, {
    children: _jsx("code", {
      children: "--use-gitignore[=<bool>]"
    })
  })
}, {
  depth: 3,
  url: "#pnpm-deploy와의-비교",
  title: _jsxs(_Fragment, {
    children: [_jsx("code", {
      children: "pnpm deploy"
    }), "와의 비교"]
  })
}];
function _createMdxContent(props) {
  const _components = {
    a: "a",
    code: "code",
    h3: "h3",
    h4: "h4",
    li: "li",
    p: "p",
    pre: "pre",
    span: "span",
    ul: "ul",
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsxs(_components.p, {
      children: ["대상 패키지에 대한 부분 모노레포를 생성합니다. 출력은 다음을 포함하는 ", _jsx(_components.code, {
        children: "out"
      }), "이라는 디렉토리에 배치됩니다:"]
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsx(_components.li, {
        children: "대상을 빌드하는 데 필요한 모든 내부 패키지의 전체 소스 코드."
      }), "\n", _jsx(_components.li, {
        children: "대상을 빌드하는 데 필요한 원본 lockfile의 하위 집합을 포함하는 정리된 lockfile."
      }), "\n", _jsxs(_components.li, {
        children: ["루트 ", _jsx(_components.code, {
          children: "package.json"
        }), "의 복사본."]
      }), "\n"]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsx(_components.code, {
          children: _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " prune"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " [package]"
            })]
          })
        })
      })
    }), "\n", _jsx(_components.h3, {
      id: "예제",
      children: "예제"
    }), "\n", _jsx(_components.p, {
      children: "다음 구조의 저장소로 시작합니다:"
    }), "\n", _jsxs(Files, {
      children: [_jsx(File, {
        name: "package.json"
      }), _jsx(File, {
        name: "pnpm-lock.yaml"
      }), _jsxs(Folder, {
        name: "apps",
        defaultOpen: true,
        children: [_jsxs(Folder, {
          name: "admin",
          children: [_jsx(File, {
            name: "package.json"
          }), _jsx(File, {
            name: "next-env.d.ts"
          }), _jsx(File, {
            name: "next.config.js"
          }), _jsx(Folder, {
            name: "src",
            children: _jsx(Folder, {
              name: "app",
              children: _jsx(File, {
                name: "page.tsx"
              })
            })
          }), _jsx(File, {
            name: "tsconfig.json"
          })]
        }), _jsxs(Folder, {
          name: "frontend",
          children: [_jsx(File, {
            name: "package.json"
          }), _jsx(File, {
            name: "next-env.d.ts"
          }), _jsx(File, {
            name: "next.config.js"
          }), _jsx(Folder, {
            name: "src",
            children: _jsx(Folder, {
              name: "app",
              children: _jsx(File, {
                name: "page.tsx"
              })
            })
          }), _jsx(File, {
            name: "tsconfig.json"
          })]
        })]
      }), _jsxs(Folder, {
        name: "packages",
        defaultOpen: true,
        children: [_jsxs(Folder, {
          name: "scripts",
          children: [_jsx(File, {
            name: "package.json"
          }), _jsx(Folder, {
            name: "src",
            children: _jsx(File, {
              name: "index.tsx"
            })
          }), _jsx(File, {
            name: "tsconfig.json"
          })]
        }), _jsxs(Folder, {
          name: "shared",
          children: [_jsx(File, {
            name: "package.json"
          }), _jsxs(Folder, {
            name: "src",
            children: [_jsxs(Folder, {
              name: "__tests__",
              children: [_jsx(File, {
                name: "sum.test.ts"
              }), _jsx(File, {
                name: "tsconfig.json"
              })]
            }), _jsx(File, {
              name: "index.ts"
            }), _jsx(File, {
              name: "sum.ts"
            })]
          }), _jsx(File, {
            name: "tsconfig.json"
          })]
        }), _jsxs(Folder, {
          name: "ui",
          children: [_jsx(File, {
            name: "package.json"
          }), _jsx(Folder, {
            name: "src",
            children: _jsx(File, {
              name: "index.tsx"
            })
          }), _jsx(File, {
            name: "tsconfig.json"
          })]
        }), _jsxs(Folder, {
          name: "utils",
          children: [_jsx(File, {
            name: "package.json"
          }), _jsx(Folder, {
            name: "src",
            children: _jsx(File, {
              name: "index.tsx"
            })
          }), _jsx(File, {
            name: "tsconfig.json"
          })]
        })]
      })]
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.code, {
        children: "turbo prune frontend"
      }), "를 실행하여 ", _jsx(_components.code, {
        children: "out"
      }), " 디렉토리에 ", _jsx(_components.code, {
        children: "frontend"
      }), " 애플리케이션에 대한 정리된 워크스페이스를 생성합니다:"]
    }), "\n", _jsxs(Files, {
      children: [_jsx(File, {
        name: "package.json"
      }), _jsx(File, {
        name: "pnpm-lock.yaml (partial)"
      }), _jsx(Folder, {
        name: "apps",
        defaultOpen: true,
        children: _jsxs(Folder, {
          name: "frontend",
          children: [_jsx(File, {
            name: "package.json"
          }), _jsx(File, {
            name: "next-env.d.ts"
          }), _jsx(File, {
            name: "next.config.js"
          }), _jsx(Folder, {
            name: "src",
            children: _jsx(Folder, {
              name: "app",
              children: _jsx(File, {
                name: "page.tsx"
              })
            })
          }), _jsx(File, {
            name: "tsconfig.json"
          })]
        })
      }), _jsxs(Folder, {
        name: "packages",
        defaultOpen: true,
        children: [_jsxs(Folder, {
          name: "shared",
          children: [_jsx(File, {
            name: "package.json"
          }), _jsxs(Folder, {
            name: "src",
            children: [_jsxs(Folder, {
              name: "__tests__",
              children: [_jsx(File, {
                name: "sum.test.ts"
              }), _jsx(File, {
                name: "tsconfig.json"
              })]
            }), _jsx(File, {
              name: "index.ts"
            }), _jsx(File, {
              name: "sum.ts"
            })]
          }), _jsx(File, {
            name: "tsconfig.json"
          })]
        }), _jsxs(Folder, {
          name: "ui",
          children: [_jsx(File, {
            name: "package.json"
          }), _jsx(Folder, {
            name: "src",
            children: _jsx(File, {
              name: "index.tsx"
            })
          }), _jsx(File, {
            name: "tsconfig.json"
          })]
        })]
      })]
    }), "\n", _jsx(_components.h3, {
      id: "옵션",
      children: "옵션"
    }), "\n", _jsx(_components.h4, {
      id: "--docker",
      children: _jsx(_components.code, {
        children: "--docker"
      })
    }), "\n", _jsxs(_components.p, {
      children: ["기본값: ", _jsx(_components.code, {
        children: "false"
      }), "."]
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.a, {
        href: "https://docs.docker.com/develop/develop-images/dockerfile_best-practices/",
        children: "Docker 모범 사례 및 레이어 캐싱"
      }), "과 함께 사용하기 쉽도록 출력 디렉토리를 변경합니다. 디렉토리에는 다음이 포함됩니다:"]
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["정리된 워크스페이스의 ", _jsx(_components.code, {
          children: "package.json"
        }), " 파일이 있는 ", _jsx(_components.code, {
          children: "json"
        }), "이라는 폴더."]
      }), "\n", _jsxs(_components.li, {
        children: ["대상을 빌드하는 데 필요한 내부 패키지의 정리된 워크스페이스 전체 소스 코드가 있는 ", _jsx(_components.code, {
          children: "full"
        }), "이라는 폴더."]
      }), "\n", _jsx(_components.li, {
        children: "대상을 빌드하는 데 필요한 원본 lockfile의 하위 집합을 포함하는 정리된 lockfile."
      }), "\n"]
    }), "\n", _jsxs(_components.p, {
      children: ["위의 동일한 예제를 사용하여 ", _jsx(_components.code, {
        children: "turbo prune frontend --docker"
      }), "를 실행하면 다음이 생성됩니다:"]
    }), "\n", _jsxs(Files, {
      children: [_jsx(File, {
        name: "pnpm-lock.yaml (partial)"
      }), _jsxs(Folder, {
        name: "full",
        defaultOpen: true,
        children: [_jsx(File, {
          name: "package.json (from repo root)"
        }), _jsx(Folder, {
          name: "apps",
          children: _jsxs(Folder, {
            name: "frontend",
            children: [_jsx(File, {
              name: "package.json"
            }), _jsx(File, {
              name: "next-env.d.ts"
            }), _jsx(File, {
              name: "next.config.js"
            }), _jsx(Folder, {
              name: "src",
              children: _jsx(Folder, {
                name: "app",
                children: _jsx(File, {
                  name: "page.tsx"
                })
              })
            }), _jsx(File, {
              name: "tsconfig.json"
            })]
          })
        }), _jsxs(Folder, {
          name: "packages",
          children: [_jsxs(Folder, {
            name: "shared",
            children: [_jsx(File, {
              name: "package.json"
            }), _jsxs(Folder, {
              name: "src",
              children: [_jsxs(Folder, {
                name: "__tests__",
                children: [_jsx(File, {
                  name: "sum.test.ts"
                }), _jsx(File, {
                  name: "tsconfig.json"
                })]
              }), _jsx(File, {
                name: "index.ts"
              }), _jsx(File, {
                name: "sum.ts"
              })]
            }), _jsx(File, {
              name: "tsconfig.json"
            })]
          }), _jsxs(Folder, {
            name: "ui",
            children: [_jsx(File, {
              name: "package.json"
            }), _jsx(Folder, {
              name: "src",
              children: _jsx(File, {
                name: "index.tsx"
              })
            }), _jsx(File, {
              name: "tsconfig.json"
            })]
          })]
        })]
      }), _jsxs(Folder, {
        name: "json",
        defaultOpen: true,
        children: [_jsx(File, {
          name: "package.json (from repo root)"
        }), _jsx(Folder, {
          name: "apps",
          defaultOpen: true,
          children: _jsx(Folder, {
            name: "frontend",
            defaultOpen: true,
            children: _jsx(File, {
              name: "package.json"
            })
          })
        }), _jsxs(Folder, {
          name: "packages",
          defaultOpen: true,
          children: [_jsx(Folder, {
            name: "ui",
            defaultOpen: true,
            children: _jsx(File, {
              name: "package.json"
            })
          }), _jsx(Folder, {
            name: "shared",
            defaultOpen: true,
            children: _jsx(File, {
              name: "package.json"
            })
          })]
        })]
      })]
    }), "\n", _jsx(_components.h4, {
      id: "--out-dir-path",
      children: _jsx(_components.code, {
        children: "--out-dir <path>"
      })
    }), "\n", _jsxs(_components.p, {
      children: ["기본값: ", _jsx(_components.code, {
        children: "./out"
      }), "."]
    }), "\n", _jsx(_components.p, {
      children: "정리된 출력이 생성되는 디렉토리를 사용자 정의합니다."
    }), "\n", _jsx(_components.h4, {
      id: "--use-gitignorebool",
      children: _jsx(_components.code, {
        children: "--use-gitignore[=<bool>]"
      })
    }), "\n", _jsxs(_components.p, {
      children: ["기본값: ", _jsx(_components.code, {
        children: "true"
      })]
    }), "\n", _jsxs(_components.p, {
      children: ["출력 디렉토리로 파일을 복사할 때 ", _jsx(_components.code, {
        children: ".gitignore"
      }), " 파일을 준수합니다."]
    }), "\n", _jsxs(_components.h3, {
      id: "pnpm-deploy와의-비교",
      children: [_jsx(_components.code, {
        children: "pnpm deploy"
      }), "와의 비교"]
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.code, {
        children: "turbo prune"
      }), "와 ", _jsx(_components.a, {
        href: "https://pnpm.io/cli/deploy",
        children: _jsx(_components.code, {
          children: "pnpm deploy"
        })
      }), " 모두 모노레포의 패키지를 격리하는 데 사용되지만 서로 다른 목적을 제공하고 다른 출력을 생성합니다."]
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.code, {
        children: "turbo prune"
      }), "이 부분 모노레포를 생성하는 반면, ", _jsx(_components.code, {
        children: "pnpm deploy"
      }), "는 대상 패키지의 내용만 포함하는 디렉토리를 생성합니다."]
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.code, {
        children: "pnpm deploy"
      }), "가 생성한 디렉토리에는 하드 링크된 내부 의존성이 있는 자체 포함된 ", _jsx(_components.code, {
        children: "node_modules"
      }), "가 있습니다.\n이로 인해 서버에 직접 복사하여 추가 단계 없이 사용할 수 있는 이식 가능한 패키지가 생성됩니다.\n저장소 구조는 유지되지 않는데, 이는 독립 실행형 배포 가능 패키지를 생성하는 데 중점을 두기 때문입니다."]
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
